/**
 * Helper to parse tool results that might be Python-style strings.
 * Shared between streaming (useAIChatStreamHandler) and session loading (useSessionLoader).
 */
const parseToolResult = (result: any) => {
    if (typeof result !== 'string') return result;

    try {
        return JSON.parse(result);
    } catch {
        try {
            // Handle Python-style string representation with complex objects
            let fixed = result;

            // Replace Python UUID() objects with string UUIDs
            // Example: UUID('4c0a81ce-7fe9-4954-9d1b-c6923a866a2e') -> "4c0a81ce-7fe9-4954-9d1b-c6923a866a2e"
            fixed = fixed.replace(/UUID\('([^']+)'\)/g, '"$1"');

            // Replace Python datetime.datetime() objects with ISO strings
            // Example: datetime.datetime(2025, 12, 18, 13, 19, 57, 783889, tzinfo=datetime.timezone.utc) -> "2025-12-18T13:19:57.783Z"
            fixed = fixed.replace(
                /datetime\.datetime\((\d+),\s*(\d+),\s*(\d+),\s*(\d+),\s*(\d+),\s*(\d+),\s*(\d+)[^)]*\)/g,
                (_match: string, year: string, month: string, day: string, hour: string, minute: string, second: string, microsecond: string) => {
                    const isoDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}.${String(microsecond).padStart(6, '0').slice(0, 3)}Z`;
                    return `"${isoDate}"`;
                }
            );

            // Replace Python None, True, False
            fixed = fixed
                .replace(/\bNone\b/g, 'null')
                .replace(/\bTrue\b/g, 'true')
                .replace(/\bFalse\b/g, 'false');

            // Replace single quotes with double quotes for proper JSON
            // But we need to be careful about nested quotes and apostrophes in strings
            // First, temporarily replace escaped single quotes
            fixed = fixed.replace(/\\'/g, '___ESCAPED_QUOTE___');

            // Then replace single quotes with double quotes
            fixed = fixed.replace(/'/g, '"');

            // Restore escaped quotes as proper escaped double quotes
            fixed = fixed.replace(/___ESCAPED_QUOTE___/g, '\\"');

            return JSON.parse(fixed);
        } catch {
            // Return original result if parsing fails
            return result;
        }
    }
};

export default parseToolResult;
